export default __webpack_public_path__ + "static/media/IMG6029.12ea4491.jpg";